import React, { useState, useEffect } from "react";
import Logo from "../Logo";
import Collapse from "./Collapse";
import {
  ProSidebar,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
  Menu,
  MenuItem,
  SubMenu,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import { AiFillHome } from "react-icons/ai";
import { FiUpload } from "react-icons/fi";
import { RiUserAddFill } from "react-icons/ri";
import { FaPowerOff, FaUser, FaUpload } from "react-icons/fa";
import { Link } from "react-router-dom";
import withSizes from "react-sizes";
import "./Sidebar.css";
import Navbarmobile from "../Navbarmobile";
import CollapsedLogo from "./CollapsedLogo";
import SideLink from "./SideLink";
import HelpVideo from '../HelpVideo';
import { useAppStore, useUserStore } from "../../stores"

const Sidebar = ({ winHeight, winWidth, navLinks, ...props }) => {
  const [collapseSidebar, setcollapseSidebar] = useState(false);
  const [mobileCollapseSidebar, setmobileCollapseSidebar] = useState(false);
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);
  const user = useUserStore((state) => state.data);
  const userLogout = useUserStore((state) => state.logout);
  console.log(navLinks);
  const handleLogout = async () => {
    showLoading();
    const r = await fetch("/api/logout");
    hideLoading();
    if (r.status == 200) {
      // const res = await r.json();
      userLogout();
    }
    else {
      alert("Could not logout");
    }
  }
  const onCollapseHandler = () => {
    setcollapseSidebar(!collapseSidebar);
  };
  const onMobileCollapseHandler = () => {
    // setcollapseSidebar(mobileCollapseSidebar);
    console.log(winWidth);
    if (winWidth <= 850) {
      setcollapseSidebar(false);
      setmobileCollapseSidebar(!mobileCollapseSidebar);
    }
  };
  useEffect(() => {
    if (winWidth <= 850) {
      if (mobileCollapseSidebar) {
        window.$("#fixedsidebar").show();
      } else {
        setTimeout(() => {
          window.$("#fixedsidebar").hide();
          // call again if window is rotated/resized due to async operation
          setmobileCollapseSidebar(false);
        }, 350);
        // window.$('#fixedsidebar').fadeOut(350);
      }
    } else {
      window.$("#fixedsidebar").removeClass("in-left");
      window.$("#fixedsidebar").removeClass("out-left");
      setTimeout(() => {
        window.$("#fixedsidebar").show();
      }, 500);
    }
  });
  return (
    <>
      <Navbarmobile
        mobileCollapseSidebar={mobileCollapseSidebar}
        onMobileCollapseHandler={onMobileCollapseHandler}
        id="navbarmobile"
        style={{ display: "none" }}
      />
      <ProSidebar
        collapsed={collapseSidebar}
        value={mobileCollapseSidebar}
        data-payload={collapseSidebar}
        id="fixedsidebar"
        className={
          mobileCollapseSidebar
            ? "in-left sidebar"
            : winWidth > 850
              ? "sidebar"
              : "out-left sidebar"
        }
      >
        <SidebarHeader
          style={{
            position: "relative",
            height: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "none",
          }}
        >
          {collapseSidebar ? (
            <CollapsedLogo />
          ) : (
            <img
              src={"/images/sreenidhiL.jpg"}
              alt="SNIST logo"
              className="mobilelogodisable"
              style={{ height: "75px", borderRadius: "10px" }}
            />
          )}
        </SidebarHeader>
        <Collapse
          collapseSidebar={collapseSidebar}
          onCollapseHandler={onCollapseHandler}
        />
        <Menu iconShape="circle">
          <SideLink to={navLinks.home} activeClass={!collapseSidebar ? "menuItemLight" : "collapsedMenuItemLight"} iconShape="circle" style={{ fontWeight: "700" }} icon={<AiFillHome />}>
            Home
          </SideLink>
          {
            navLinks.upload ?
              <SideLink to={navLinks.home} activeClass={!collapseSidebar ? "menuItemLight" : "collapsedMenuItemLight"} iconShape="circle" style={{ fontWeight: "700" }} icon={<FaUpload />}>
                Upload
              </SideLink>
              : <></>
          }
          {navLinks.addRole.map(role => {
            return (
              <SideLink to={role.url} activeClass={!collapseSidebar ? "menuItemLight" : "collapsedMenuItemLight"} iconShape="circle" style={{ fontWeight: "700" }} icon={<RiUserAddFill />}>
                {role.title}
              </SideLink>
            )
          })}
          <SideLink to={navLinks.profile} activeClass={!collapseSidebar ? "menuItemLight" : "collapsedMenuItemLight"} iconShape="circle" style={{ fontWeight: "700" }} icon={<FaUser />}>
            Profile
          </SideLink>
          <HelpVideo collapseSidebar={collapseSidebar} />
          {/* <SubMenu title="Components">
            <MenuItem>Component 1</MenuItem>
            <MenuItem>Component 2</MenuItem>
          </SubMenu> */}
        </Menu>
        <SidebarFooter>
          <footer className="footer">
            <Menu iconShape="circle" style={{ paddingTop: "5px" }}>
              <MenuItem
                icon={<FaPowerOff style={{ color: "gray" }} />}
                id="logoutBtn"
                className={!collapseSidebar ? "menuItemLight" : ""}
                onClick={handleLogout}
              >
                Logout
                {/* <Link to="/" onClick={handleLogout} /> */}
              </MenuItem>
              {!collapseSidebar ? (
                <MenuItem
                  style={{ display: "flex", borderTop: "1px solid grey" }}
                >
                  <span>Powered by &ensp;</span>
                  <Logo id="sidebarLogo" />
                </MenuItem>
              ) : (
                <></>
              )}
            </Menu>
          </footer>
        </SidebarFooter>
      </ProSidebar>
    </>
  );
};

const mapSizesToProps = ({ height, width }) => ({
  winHeight: height,
  winWidth: width,
});
export default withSizes(mapSizesToProps)(Sidebar);
